import { runScript } from './runScript';

runScript(false);
